<template>
  <div :class="['custom_container', { 'no-background': noBackgroundColor }, height, overflowY]">
    <div v-if="header" id="custom_container_header" class="custom_container_header">
      <div class="flex flex-row gap-[6px] items-center text-sm text_color">
        <img v-if="header.icon" :class="`${header.size || 'size-4'}`" :src="header.icon" :alt="header.alt" />
        <div class="flex flex-col justify-center">
          <span class="font-medium">{{ header.title }}</span>
          <span class="text-xs secondary_color" v-if="header.description">{{ header.description }}</span>
        </div>
      </div>

      <slot name="trigger" v-if="$slots.trigger"></slot>
      <span v-else-if="header.execute && showAddButton" class="secondary_color font-normal cursor-pointer" @click="header.execute"> + Add </span>
      <span v-if="count !== null" class="text-sm secondary_color"> {{ count }} estimates </span>
    </div>

    <div :class="['flex flex-col w-full h-full', padding]">
      <slot v-if="!showEmptyScreen"></slot>

      <div class="mt-14 mb-16" v-else>
        <EmptyScreen source="custom_container" :text="header.emptyText" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import EmptyScreen from '@/components/custom/EmptyScreen.vue';

const props = defineProps({
  header: { type: Object, required: false, default: null },
  padding: { type: String, default: 'p-2' },
  height: { type: String, default: '' },
  count: { type: Number, required: false, default: null },
  showAddButton: { type: Boolean, default: true },
  noBackgroundColor: { type: Boolean, default: false },
  showEmptyScreen: { type: Boolean, default: false },
  overflowY: { type: String, default: '' },
});
</script>

<style>
.custom_container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid var(--white-opacity-8);
  background: var(--white-opacity-3);
  font-family: 'Proxima Nova', sans-serif;
}

.custom_container.no-background {
  background: transparent;
}

.custom_container_header {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--white-opacity-8);
  padding: 12px;
}
</style>
